import { games, type GameEntry } from "../content/siteContent";

export type ProjectCarouselEntry = GameEntry & {
  category: string;
  index: number;
  indexLabel: string;
  imageSrc: string;
};

const projectImageSources = [
  "/images/projects/mystic-tempo-race.jpg"
];

export const projects: ProjectCarouselEntry[] = games.map((game, index) => ({
  ...game,
  category: game.metrics[0]?.value ?? game.metrics[0]?.label ?? game.title,
  index,
  indexLabel: String(index + 1).padStart(2, "0"),
  imageSrc: projectImageSources[index % projectImageSources.length]
}));
